export default "__VITE_ASSET__ziM$1zWi__"